define((require) => {
    "use strict";

    var _                            = require("underscore"),
        ActionFactory                = require("shared/ui/experience/action/ActionFactory"),
        ActionHelper                 = require("ui/experience/action/ActionHelper"),
        ActionsView                  = require("ui/experience/action/ActionsView"),
        EffectsView                  = require("ui/experience/action/EffectsView"),
        LoggedInUserState            = require("shared/ui/user/LoggedInUserState"),
        {Logger}                     = require("shared/util/Logger"),
        template                     = require("ui/experience/action/ActionPropertiesView.tpl"),
        AbstractWidgetPropertiesView = require("ui/experience/widgets/AbstractWidgetPropertiesView");

    var log = new Logger("ActionPropertiesView");

    var EXPAND_PROPERTY = "actionExpanded";

    /**
     * The actions collapsible containing the actions drop down menu and the properties view for
     * the selected action.
     */
    return AbstractWidgetPropertiesView.extend("ActionPropertiesView", {
        expandProperty: EXPAND_PROPERTY,

        template: template,

        templateHelpers: function() {
            var panelName = this.options.onlyShowProductActions ?
                "Product Actions" :
                "Actions";

            return {
                panelName: panelName,
                showEffects: this.options.showEffects
            };
        },

        regions: {
            actionsRegion: ".actions-region",
            effectsRegion: ".effects-region",
            onLoadsRegion: ".onloads-region"
        },

        ui: {
            container: ".action-properties-accordion",
            legend: "[data-target=\".action-properties-accordion\"]"
        },

        initialize: function() {
            this.options = _.defaults(this.options, {
                onlyShowProductActions: false,
                showEffects: true
            });
        },

        onRender: function() {
            this.__super();

            // Actions are not supported on the background scene
            if (this.viewScope.viewModel.get("isBackgroundScene")) {
                this.$el.hide();
            }
        },

        _showActionView() {
            this.actionsRegion.show(new ActionsView({
                model: this.model,
                onlyShowProductActions: this.options.onlyShowProductActions
            }));
        },

        onShow: function() {
            this.__super();

            this.listenTo(this.viewScope.viewModel.get("experience"), "change:emailModeEnabled", () => {
                this._showActionView();
            });

            if (this.model.get("defaultActionId") && !this.model.get("defaultValueHasBeenSet")) {
                this._setDefaultAction();
            }

            if (this.options.showEffects) {
                this.effectsRegion.show(new EffectsView({model: this.model, viewModel: this.viewScope.viewModel}));
            }

            this._showActionView();

            this.onLoadsRegion.show(this._setOnLoadAction({model: this.model}));
        },

        _setDefaultAction: function() {
            this.model.set("defaultValueHasBeenSet", true);

            // Guard against the defaultActionId not being configured correctly.
            var prototypeAction = LoggedInUserState.get("prototypeActionCollection").findWhere({"id": this.model.get("defaultActionId")});
            if (prototypeAction === undefined) {
                log.warn("The default action with ID '" + this.model.get("defaultActionId") + "' was not found.");
                return;
            }

            // Matches what Action.getIndetifier() returns.
            var actionIdentifier = {
                actionId: this.model.get("defaultActionId"),
                type: prototypeAction.get("action").get("type")
            };
            var options = ActionHelper.getActionOptions(actionIdentifier);
            var defaultAction = ActionFactory.newActionFromType(actionIdentifier.type, options);

            this.model.set("action", defaultAction);
        }
    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/ActionPropertiesView.js